import { fetchTransactions } from './fetchTransactions'

export const ProfileController = {
  fetchTransactions,
}
